import lodash from "lodash";
import React from "react";
import { TIPTAP_FIGURE_TYPE } from "./../ricos-content";
import { Link_Target } from "./../ricos-schema/legacy/wix/rich_content/v1";
import { toggleLinkModal } from "./../_shared/link-modal/toggle-link-modal";
import {
  decorateComponentWithProps,
  PLUGIN_TOOLBAR_BUTTON_ID
} from "./../editor-common";
import {
  getVisibleOnlyOnDesktopResolver,
  selectedNodeResolver
} from "./../plugin-commons";
import {
  AlignmentPanel,
  DeleteButton,
  NodeAlignmentButton,
  NodeSizeButton,
  SizePanel
} from "./../toolbars-ui";
import {
  FLOATING_PLUGIN_TOOLBAR,
  getNodeLinkDataResolver,
  isNodeContainsLinkOrAnchorResolver
} from "./../toolbars-v3";
import {
  IMAGE_BUTTONS,
  IMAGE_EDITOR_MODAL_ID,
  IMAGE_SETTINGS_MODAL_ID,
  PLUGIN_TOOLBAR_BUTTON_ID_IMAGE_EDITOR
} from "./consts";
import { PLUGIN_TOOLBAR_IMAGE_EDITOR_BUTTON, PLUGIN_TOOLBAR_LINK_BUTTON } from "./data-hooks";
import { handleImageUpload } from "./handle-image-upload";
import ImageEditorModal from "./image-editor-modal/image-editor-modal";
import { Settings } from "./settings/settings";
import ImageEditorButton from "./toolbar/ImageEditorButton";
const getToolbarButtons = (config, services) => {
  const {
    modals,
    context: { isMobile }
  } = services;
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SIZE,
      modal: {
        Component: decorateComponentWithProps(SizePanel, {
          options: [
            "SMALL",
            "CONTENT",
            "FULL_WIDTH",
            "ORIGINAL"
          ]
        }),
        id: IMAGE_BUTTONS.size
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeSizeButton, { id: IMAGE_BUTTONS.size, toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: IMAGE_BUTTONS.alignment
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: IMAGE_BUTTONS.alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID_IMAGE_EDITOR,
      modal: {
        Component: decorateComponentWithProps(ImageEditorModal, {
          config
        }),
        id: IMAGE_EDITOR_MODAL_ID
      },
      dataHook: PLUGIN_TOOLBAR_IMAGE_EDITOR_BUTTON,
      command: ({ src, attributes: { selectedNode } }) => {
        modals?.openRegisteredModal(IMAGE_EDITOR_MODAL_ID, {
          componentProps: {
            nodeId: selectedNode.attrs.id,
            src,
            handleFileUpload: config.handleFileUpload
          },
          positioning: { placement: "top" },
          layout: "fullscreen"
        });
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(ImageEditorButton, { toolbarItem }),
      attributes: {
        visible: getIsEditImageVisibleResolver(config, isMobile),
        selectedNode: selectedNodeResolver
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getIsEditImageVisibleResolver(config, isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.LINK,
      type: "modal",
      attributes: {
        active: isNodeContainsLinkOrAnchorResolver,
        linkData: getNodeLinkDataResolver
      },
      command: ({
        attributes,
        tiptapEditor,
        modals: modalService,
        pluginsEvents,
        referenceElement
      }) => {
        const onSave = (link) => {
          const { attrs } = attributes.selectedNode;
          tiptapEditor.chain().focus().setNodeAttrsById(attrs.id, { ...attrs, link }).run();
          pluginsEvents.publishPluginLinkable({
            pluginId: attributes.selectedNode.type.name,
            nodeId: attributes.selectedNode.attrs.id,
            link: link.url,
            newTab: link.target === Link_Target.BLANK,
            nofollow: link.rel?.nofollow
          });
        };
        const onUnlink = () => {
          const { link, ...attrs } = attributes.selectedNode.attrs;
          tiptapEditor.chain().focus().setNodeAttrsById(attrs.id, attrs).run();
        };
        toggleLinkModal({
          initialValue: attributes.linkData,
          modalService,
          onSave,
          onUnlink,
          referenceElement
        });
      },
      dataHook: PLUGIN_TOOLBAR_LINK_BUTTON
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS,
      attributes: {
        active: {
          id: "IS_IMAGE_SETTINGS_BUTTON_ACTIVE",
          resolve: (_, { modals: modals2 }) => Boolean(modals2.getModal(IMAGE_SETTINGS_MODAL_ID))
        }
      },
      command: ({ isMobile: isMobile2, referenceElement, attributes: { selectedNode } }) => {
        modals?.togglePluginPanel({
          id: IMAGE_SETTINGS_MODAL_ID,
          Component: Settings,
          componentProps: {
            referenceElement,
            nodeId: selectedNode.attrs.id,
            config
          },
          positioning: {
            referenceElement: referenceElement.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ?? referenceElement,
            placement: "right-start"
          },
          onClickOutside: {
            on: "pointerup",
            handler: lodash.noop
          },
          focusReturnElement: referenceElement,
          isMobile: isMobile2
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      tooltip: "ReplaceImageButton_Tooltip",
      command: ({ attributes: { selectedNode }, publicCommands }) => {
        handleImageUpload({
          services,
          config,
          publicCommands,
          nodeId: selectedNode.attrs.id
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE,
      renderer: (toolbarItem) => {
        return /* @__PURE__ */ React.createElement(DeleteButton, { toolbarItem });
      },
      command: (data) => {
        const figures = data.tiptapEditor.$nodes(TIPTAP_FIGURE_TYPE);
        const selectedFigure = figures?.find((f) => {
          return f.firstChild?.node.attrs.id === data.attributes.selectedNode.attrs.id;
        });
        if (selectedFigure) {
          data.tiptapEditor.chain().focus().deleteNode(selectedFigure.attributes.id).run();
        }
      }
    }
  ];
};
const getIsEditImageVisibleResolver = (config, isMobile) => ({
  id: "IS_IMAGE_EDIT_BUTTON_VISIBLE",
  resolve: () => !!config.imageEditorWixSettings && !isMobile
});
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
